import { Button } from "antd";
import { useContext } from "react";
import { TemplateContext2Provider } from "../../contexts/TemplateContext2";

export default function QuestionReUsable({
  templateData,
  questionBackgroundColor,
  questionsFontColor,
  OpaqueDeciderForQuestionForm = () => null,
  noSpace = false,
}) {
  const { rowNineAlignment, rowNineHeaderText } = useContext(
    TemplateContext2Provider
  );

  return (
    <>
      <div className="question-form">
        <div
          className="question-form-content"
          style={{
            ...OpaqueDeciderForQuestionForm(),
            marginLeft:
              rowNineAlignment === "center"
                ? "auto"
                : rowNineAlignment === "left"
                ? "0"
                : "auto",
            marginRight:
              rowNineAlignment === "center"
                ? "auto"
                : rowNineAlignment === "left"
                ? "auto"
                : "0",
          }}
        >
          <div style={{ paddingBottom: '4%', textAlign: rowNineAlignment, }}>
            <Button style={{ background: questionsFontColor, color: questionBackgroundColor, border: 'none', height: '40px' }} onClick={() => window.open(templateData?.redirectButtonUrl ?? '')}>{templateData?.redirectButtonText ?? ''}</Button>
          </div>
        </div>
      </div>
    </>
  );
}
